import Store from "./Store";
import Answer from "../../model/answer.model";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export default class AnswerStore extends Store<Answer> {
  protected override name: string = "answers";
}
